import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import ExploreContent from "@/components/ExploreContent";
import ExploreMobile from "@/components/explore/ExploreMobile";
import { useIsMobile } from "@/hooks/use-mobile";

const Explore = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <ExploreMobile />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <ExploreContent />
      </main>
      <SiteFooter />
    </div>
  );
};

export default Explore;
